module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_17_m.2bcb8411354b917f5b75f7b9c47cdef5.png";